import React, {useState, useRef} from 'react';
import './App.css';
import {Download, Play} from "lucide-react";
import omnigenLogo from "./omnigen-company-logo.png";

function App () {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    classification: 'Nódulo Bethesda I y II',
    comments: '',
    termsAccepted: false
  });
  const [activeTab, setActiveTab] = useState(1);
  const [activeFaq, setActiveFaq] = useState(null);

    // --- video state & ref ---
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);


    const toggleFaq = (index) => {
    if (activeFaq === index) {
      setActiveFaq(null);
    } else {
      setActiveFaq(index);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Burada form gönderme işlemini yapabilirsiniz
    alert('Teşekkürler! En geç 48 iş saati içinde sizinle iletişime geçeceğiz.');
  };
  const documents = [
    {
      name: "ThyroidPrint Tanıtım Broşürü",
      file: "/docs/ThyroidPrint_Omnigen_Tanitim.pdf",
      description: "ThyroidPrint hakkında genel bilgiler"
    },
    {
      name: "ThyroidPrint High/Low Örnek Sonuç Raporu",
      file: "/docs/ThyroidPrint_HIGH LOW_Sonuc_Rapor.pdf",
      description: "Yüksek ve düşük risk sonuçları"
    },
  ];

    // Play butonu davranışı
    const handlePlay = () => {
        if (!videoRef.current) return;

        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.muted = false;
            videoRef.current.play();
        }

        setIsPlaying(!isPlaying);
    };

  return (
    <div className="app">
      {/* Header/Navigation */}
      <header className="header">
        <div className="header-container">
          <div className="header-top">
            <a href="/" className="logo-link">
              <img
                src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/66d897f21cf7eb0e2e957518_logo%7D.png"
                alt="ThyroidPrint®" className="logo"/>
            </a>
            <div className="nav-links">
              <a href="#thyroidprint" className="nav-link">ThyroidPrint® Nedir?</a>
              <a href="#contact" className="nav-link">İletişim</a>
            </div>
          </div>
          {/*<div className="main-nav-wrapper">*/}
          {/*  <nav className="main-nav">*/}
          {/*    <ul className="nav-menu">*/}
          {/*      <li className="nav-item"><a href="/" className="nav-link">Home</a></li>*/}
          {/*      <li className="nav-item"><a href="/pacientes/thyroidprint" className="nav-link active">ThyroidPrint</a></li>*/}
          {/*      <li className="nav-item"><a href="/pacientes/como-solicito-el-test" className="nav-link">Request the test</a></li>*/}
          {/*      <li className="nav-item"><a href="/pacientes/quienes-somos" className="nav-link">Who We Are</a></li>*/}
          {/*      <li className="nav-item"><a href="/blog/blog-pacientes" className="nav-link">Blog</a></li>*/}
          {/*      <li className="nav-item"><a href="/noticias/noticias" className="nav-link">News</a></li>*/}
          {/*    </ul>*/}
          {/*    <div className="contact-btn">*/}
          {/*      <a href="/pacientes/contactanos" className="button primary-button">Contact</a>*/}
          {/*    </div>*/}
          {/*  </nav>*/}
          {/*</div>*/}
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero" style={{backgroundImage: "url('/images/hero-thyroid-2.png')"}}>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-text">
              <h2 className="heading-1">ThyroidPrint®</h2>
              <h2 className="heading-2" style={{
                fontSize: "40px",
                fontWeight: 300,
                marginBottom: "20px",
                lineHeight: "1.3",
                whiteSpace: "normal",
                textAlign: "left",
                flexGrow: 1,
                flexBasis: "100%",
                maxWidth: "100%",
                width: "100%"
              }}>ThyroidPrint ile belirsizliği ortadan kaldırın!</h2>
              <p className="hero-description" style={{color: "rgb(144, 36, 92)", fontSize: "30px", fontWeight: 700}}>
                {/*#KeepYourThyroid*/}
              </p>
            </div>
            <div className="contact-form">
              {/*<h2 className="form-title">I WANT MORE INFORMATION</h2>*/}
              {/*<form className="info-form" onSubmit={handleSubmit}>*/}
              {/*  <div className="form-row">*/}
              {/*    <input*/}
              {/*      type="text"*/}
              {/*      className="form-input"*/}
              {/*      name="name"*/}
              {/*      placeholder="Full name"*/}
              {/*      required*/}
              {/*      value={formData.name}*/}
              {/*      onChange={handleInputChange}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*  <div className="form-row">*/}
              {/*    <input*/}
              {/*      type="email"*/}
              {/*      className="form-input"*/}
              {/*      name="email"*/}
              {/*      placeholder="Mail"*/}
              {/*      required*/}
              {/*      value={formData.email}*/}
              {/*      onChange={handleInputChange}*/}
              {/*    />*/}
              {/*  </div>*/}
              {/*  <div className="form-row">*/}
              {/*    <label className="form-label">Phone</label>*/}
              {/*    <div className="phone-input-wrapper">*/}
              {/*      <input*/}
              {/*        type="tel"*/}
              {/*        className="form-input"*/}
              {/*        name="phone"*/}
              {/*        placeholder="Phone"*/}
              {/*        required*/}
              {/*        value={formData.phone}*/}
              {/*        onChange={handleInputChange}*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*  </div>*/}
              {/*  <div className="form-row">*/}
              {/*    <label className="form-label">Classification of your nodule</label>*/}
              {/*    <select*/}
              {/*      className="form-select"*/}
              {/*      name="classification"*/}
              {/*      required*/}
              {/*      value={formData.classification}*/}
              {/*      onChange={handleInputChange}*/}
              {/*    >*/}
              {/*      <option value="Nódulo Bethesda I y II">Bethesda nodule I and II</option>*/}
              {/*      <option value="Nódulo Bethesda III y IV">Bethesda nodule III and IV</option>*/}
              {/*      <option value="Nódulo Bethesda V y VI">Bethesda nodule V and VI</option>*/}
              {/*      <option value="Sin Diagnóstico">Without Diagnosis</option>*/}
              {/*    </select>*/}
              {/*  </div>*/}
              {/*  <div className="form-row">*/}
              {/*    <label className="form-label">Comments</label>*/}
              {/*    <textarea*/}
              {/*      className="form-textarea"*/}
              {/*      name="comments"*/}
              {/*      placeholder="Message"*/}
              {/*      value={formData.comments}*/}
              {/*      onChange={handleInputChange}*/}
              {/*    ></textarea>*/}
              {/*  </div>*/}
              {/*  <div className="form-row">*/}
              {/*    <label className="checkbox-container">*/}
              {/*      <input*/}
              {/*        type="checkbox"*/}
              {/*        name="termsAccepted"*/}
              {/*        required*/}
              {/*        checked={formData.termsAccepted}*/}
              {/*        onChange={handleInputChange}*/}
              {/*      />*/}
              {/*      <span className="checkmark"></span>*/}
              {/*      I accept <a href="https://www.thyroidprint.com/legal/terms-conditions" target="_blank" rel="noreferrer" className="terms-link">Terms and Conditions.</a>*/}
              {/*    </label>*/}
              {/*  </div>*/}
              {/*  <button type="submit" className="submit-button">Submit</button>*/}
              {/*</form>*/}
            </div>
          </div>
        </div>
      </section>

      {/* What is ThyroidPrint Section */}
      <section className="what-is-section" id="thyroidprint">
        <div className="container">
          <div className="center-text">
            <h2 className="section-title">ThyroidPrint'i Tanıyın</h2>
            {/*<div className="section-description">ThyroidPrint® testinin temel özelliklerini sunuyoruz.</div> {/*<div className="section-description">ThyroidPrint® testinin temel özelliklerini sunuyoruz.</div>*/}
          </div>

          <div className="tabs-container">
            <div className="tabs">
              <button className={activeTab == 1 ? 'tab-button active' : 'tab-button'}
                      onClick={() => setActiveTab(1)}>Nedir?
              </button>
              <button className={activeTab == 2 ? 'tab-button active' : 'tab-button'}
                      onClick={() => setActiveTab(2)}>Sonuç
              </button>
              <button className={activeTab == 3 ? 'tab-button active' : 'tab-button'}
                      onClick={() => setActiveTab(3)}>Faydalar
              </button>
            </div>

            <div className={activeTab == 1 ? 'tab-content active' : 'tab-content'}>
              <div className="tab-grid">
                <img
                    src="/images/pathologist-biocartis-lowres.jpg"
                  alt="DNA analysis" className="tab-image"/>
                <div className="tab-text">
                  <p>ThyroidPrint®, tiroid nodülünün sitopatoloji sonucunda önemi belirsiz atipi gelen hastaların
                    tanı belirsizliğini ortadan kaldıran bir genetik testtir. Biocartis Idylla cihazı ile ince iğne
                    aspirasyon biyopsi örneğinden 10 genetik biyobelirteç analiz edilir. Bu sayede ThyroidPrint®
                    testinin sonucuna göre hangi hastanın ameliyat edilmesi gerektiği, hangi hastanın ameliyat
                    edilmeden takibinin yapılacağı konusunda bilgi sahibi olunur.</p>
                </div>
              </div>
            </div>

            <div className={activeTab == 2 ? 'tab-content active' : 'tab-content'}>
              <div className="tab-grid">
                <img
                    src="/images/thyroidprint-tab-2.webp"
                  alt="ThyroidPrint results" className="tab-image"/>
                <div className="tab-text">
                  <p>

                    Belirsiz tiroid nodülü (Bethesda III/IV) teşhisi konulduğunda, ameliyat olup
                    olmama konusunda kararsız kalındığı anlamına gelir. ThyroidPrint testi, tiroid
                    nodülünü <strong>DÜŞÜK RİSKLİ</strong> veya <strong>YÜKSEK RİSKLİ</strong> olarak yeniden
                    sınıflandırır.
                    ThyroidPrint® testinin sonucuna göre de hangi hastanın ameliyat edilmesi, hangi
                    hastanın ameliyat edilmeden takibinin yapılacağı konusunda sonuca varılır.

                    ThyroidPrint test sonucu <strong>YÜKSEK RİSKLİ </strong> kötü huylu tümör açısından şüpheli
                    çıkarsa bu durumda kanser riski %25'ten %78'e çıkıyor ve ameliyat önerilmektedir.
                    ThyroidPrint test sonucu <strong>DÜŞÜK RİSKLİ </strong> ise bu durumda kanser riski %25'ten
                    %5'in altına düşer ve doktorunuzun takip tedavisi önermesine olanak tanır ve
                    gereksiz <strong> ameliyattan kaçınmış olunur.</strong>



                  </p>
                </div>
              </div>
            </div>

            <div className={activeTab == 3 ? 'tab-content active' : 'tab-content'}>
              <div className="tab-grid">
                <img
                    src="/images/thyroidprint-tab-3.webp"
                  alt="ThyroidPrint benefits" className="tab-image"/>
                <div className="tab-text">
                  <p>Ameliyatın çeşitli riskleri vardır, bu nedenle ameliyattan kaçınma olanağına sahip olmak ve
                    tiroidin
                    korunması çok önemlidir.
                    <br/><br/>
                    <strong> ThyroidPrint testinin faydaları :</strong>
                    <br/><br/>
                    - Belirsiz nodülün güvenli bir tanı sonucu almasına imkan verir.<br/>
                    - Ameliyattan kaçınılmasını sağlayabilir.<br/>
                    - Tiroid ameliyatıyla ilişkili ileride oluşabilecek risklerden uzak durulmasını sağlayabilir.<br/>
                    - Yaşam boyu hormonal replasmanın alınmasını engelleyebilir.<br/>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/*<div className="cta-button-container">*/}
          {/*  <a href="#" className="cta-button">I want more information</a>*/}
          {/*</div>*/}
        </div>
      </section>

        {/* --- VIDEO SECTION (revize) --- */}
        <section className="video-section">
            <div className="container">
                <div className="video-box">
                    <div className="video-outer">
                        <video
                            ref={videoRef}
                            className="video-el"
                            poster="/videos/thumbnail.png"
                            playsInline
                            // controls yok, autoplay yok
                        >
                            <source src="/videos/thyroid-tanitim.mp4" type="video/mp4"/>
                            Tarayıcınız video etiketini desteklemiyor.
                        </video>

                        {!isPlaying && (
                            <button className="play-btn" onClick={handlePlay} aria-label="Videoyu başlat">
                                <Play size={28}/>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </section>


      {/* Avoid Unnecessary Surgeries Section */}
      <section className="avoid-surgeries">
        <div className="container">
          <h2 className="section-title">GEREKSİZ AMELİYATLARDAN KAÇININ</h2>
          <div className="subtitle">ThyroidPrint® nasıl yardımcı olur?</div>
          <p className="section-paragraph">
            Ameliyat öncesinde verilen kararın doğru olduğundan emin olmak için tüm tanı seçeneklerinin
            değerlendirilmesi önemlidir. Günümüzde her hastada tiroid ameliyatı için yapılan tanı testleri
            (mikroskopik sitopatoloji çalışması) yeterli olmayabilir. Bu nedenle, güncel klinik kılavuzlar, tanı
            sürecinde etkili ve daha hassas olan moleküler testlerin kullanımını önermektedir.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-row">
            <div className="stat-column">
              <img
                src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6537b1b6ecf77a2c21a56212_75-de-las-cirugias-son-innecesarias.webp"
                alt="75% of surgeries are unnecessary" className="stat-image"/>
              <div className="stat-number">75%</div>
                <div className="stat-text">%75’e kadar gereksiz cerrahiyi önler.</div>
            </div>
            <div className="stat-column">
              <img
                src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6537b1c8ea748ca6a0d87023_web-pacientes.jpg"
                alt="95% precision" className="stat-image"/>
              <div className="stat-number">95%</div>
              <div className="stat-text">Kesinlik</div>
            </div>
            <div className="stat-column">
              <img
                src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6537b1dd3eafcfc59f109849_Porcentaje-de-cirugias-evitadas.webp"
                alt="88% avoided surgeries" className="stat-image"/>
              <div className="stat-number">88%</div>
              <div className="stat-text">Kaçınılan ameliyatlar</div>
            </div>
          </div>
        </div>
      </section>

      {/* Scientific Evidence Section */}
      {/*<section className="scientific-evidence">*/}
      {/*  <div className="container">*/}
      {/*    <div className="evidence-content">*/}
      {/*      <h2 className="section-title">Scientific evidence</h2>*/}
      {/*      <p className="section-paragraph">*/}
      {/*        Check out the scientific publications that support the ThyroidPrint® test here*/}
      {/*      </p>*/}
      {/*      <a href="https://www.thyroidprint.com/evidencia-cientifica" target="_blank" rel="noreferrer"*/}
      {/*         className="evidence-button">And</a>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Testimonials Section */}
      {/*<section className="testimonials">*/}
      {/*  <div className="container">*/}
      {/*    <h2 className="testimonials-title">Hastalarımız ne diyor?</h2>*/}
      {/*    <h2 className="testimonials-subtitle"></h2>*/}

      {/*    <div className="testimonials-grid">*/}
      {/*      <div className="testimonial">*/}
      {/*        <img*/}
      {/*          src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/65302445a3d7bc494191f6d1_Macarena.jpg"*/}
      {/*          alt="Macarena Bustamante" className="testimonial-image"/>*/}
      {/*        <a href="https://youtu.be/3U3f3HCDudM" target="_blank" rel="noreferrer" className="video-play">*/}
      {/*          <div className="play-button-container">*/}
      {/*            <img*/}
      {/*              src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6570c73f3319e6d3a4e282b6_play-button-large-brix-templates.svg"*/}
      {/*              alt="Play" className="play-button"/>*/}
      {/*          </div>*/}
      {/*        </a>*/}
      {/*        <div className="testimonial-content">*/}
      {/*          <p className="testimonial-name">Macarena Bustamante</p>*/}
      {/*          <p className="testimonial-quote">"Ameliyatın gerekli olup olmadığını bilmek iyi bir seçenektir"</p>*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className="testimonial">*/}
      {/*        <img src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/65302203c4124b4a8967bc64_Ximena.jpg"*/}
      {/*             alt="Ximena Urzúa" className="testimonial-image"/>*/}
      {/*        <a href="https://youtu.be/KeRT8zUFJbU" target="_blank" rel="noreferrer" className="video-play">*/}
      {/*          <div className="play-button-container">*/}
      {/*            <img*/}
      {/*              src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6570c73f3319e6d3a4e282b6_play-button-large-brix-templates.svg"*/}
      {/*              alt="Play" className="play-button"/>*/}
      {/*          </div>*/}
      {/*        </a>*/}
      {/*        <div className="testimonial-content">*/}
      {/*          <p className="testimonial-name">Ximena Urzúa</p>*/}
      {/*          <p className="testimonial-quote">"Gereksiz ameliyatlardan kaçınabildim"</p>*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className="testimonial">*/}
      {/*        <img src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/65301b92e87fbf23cc98769a_Maria.jpg"*/}
      {/*             alt="Maria Herrera" className="testimonial-image"/>*/}
      {/*        <a href="https://youtu.be/ilAhxrtwAq0" target="_blank" rel="noreferrer" className="video-play">*/}
      {/*          <div className="play-button-container">*/}
      {/*            <img*/}
      {/*              src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6570c73f3319e6d3a4e282b6_play-button-large-brix-templates.svg"*/}
      {/*              alt="Play" className="play-button"/>*/}
      {/*          </div>*/}
      {/*        </a>*/}
      {/*        <div className="testimonial-content">*/}
      {/*          <p className="testimonial-name">Maria Herrera</p>*/}
      {/*          <p className="testimonial-quote">"Tanısal belirsizliğimi çözebildim"</p>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/*  <section className="stats-section">*/}
      {/*    <div className="container">*/}
      {/*      <div className="stats-row">*/}
      {/*        <div className="stat-column">*/}
      {/*          <img src="/images/step1.webp" alt="Adım 1" className="stat-image"/>*/}
      {/*          <div className="stat-number">Adım 1</div>*/}
      {/*          <div className="stat-text">Bethesda III veya IV nodülü tanısı konuldu</div>*/}
      {/*        </div>*/}

      {/*        <div className="stat-column">*/}
      {/*          <img src="/images/step2.webp" alt="Adım 2" className="stat-image"/>*/}
      {/*          <div className="stat-number">Adım 2</div>*/}
      {/*          <div className="stat-text">*/}
      {/*            Hekiminiz aracılığıyla veya web sitesindeki telefonla yada e-mail kullanarak bizimle iletişime*/}
      {/*            geçin*/}
      {/*          </div>*/}
      {/*        </div>*/}

      {/*        <div className="stat-column">*/}
      {/*          <img src="/images/step3.jpg" alt="Adım 3" className="stat-image"/>*/}
      {/*          <div className="stat-number">Adım 3</div>*/}
      {/*          <div className="stat-text">Sizinle iletişime geçip tüm sorularınızı cevaplayacağız</div>*/}
      {/*        </div>*/}

      {/*        <div className="stat-column">*/}
      {/*          <img src="images/step4.jpg" alt="Adım 4" className="stat-image"/>*/}
      {/*          <div className="stat-number">Adım 4</div>*/}
      {/*          <div className="stat-text">*/}
      {/*            Biyopsi sonrası laboratuvara ulaşan numunenin sonuçlarını 1-2 iş günü içinde bildireceğiz*/}
      {/*          </div>*/}
      {/*        </div>*/}

      {/*        <div className="stat-column">*/}
      {/*          <img src="images/step4.jpg" alt="Adım 5" className="stat-image"/>*/}
      {/*          <div className="stat-number">Adım 5</div>*/}
      {/*          <div className="stat-text">*/}
      {/*            Maliyeti öğrenmek için OmniGen hasta bilgilendirme departmanına ulaşmanızı öneririz*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <style>*/}
      {/*      {`*/}
      {/*  .stats-section .container {*/}
      {/*    margin: 40px auto;*/}
      {/*    max-width: 1280px;*/}
      {/*    text-align: center;*/}
      {/*    padding: 0 10px;*/}
      {/*  }*/}

      {/*  .stats-section .stats-row {*/}
      {/*    display: flex;*/}
      {/*    flex-wrap: wrap;*/}
      {/*    justify-content: center;*/}
      {/*    gap: 16px;*/}
      {/*  }*/}

      {/*  .stat-column {*/}
      {/*    flex: 1 1 180px;*/}
      {/*    max-width: 200px;*/}
      {/*    background-color: #ffffff;*/}
      {/*    border-radius: 16px;*/}
      {/*    padding: 16px 14px;*/}
      {/*    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);*/}
      {/*    transition: transform 0.3s ease;*/}
      {/*  }*/}

      {/*  .stat-column:hover {*/}
      {/*    transform: translateY(-4px);*/}
      {/*  }*/}

      {/*  .stat-image {*/}
      {/*    width: 100%;*/}
      {/*    height: auto;*/}
      {/*    border-radius: 12px;*/}
      {/*    margin-bottom: 12px;*/}
      {/*  }*/}

      {/*  .stat-number {*/}
      {/*    font-size: 18px;*/}
      {/*    font-weight: 600;*/}
      {/*    color: #2d6bff;*/}
      {/*    margin-bottom: 6px;*/}
      {/*  }*/}

      {/*  .stat-text {*/}
      {/*    font-size: 16px;*/}
      {/*    color: #333;*/}
      {/*    line-height: 1.4;*/}
      {/*  }*/}

      {/*  @media (max-width: 768px) {*/}
      {/*    .stats-section .stats-row {*/}
      {/*      flex-direction: column;*/}
      {/*      align-items: center;*/}
      {/*    }*/}

      {/*    .stat-column {*/}
      {/*      max-width: 90%;*/}
      {/*    }*/}
      {/*  }*/}
      {/*`}*/}
      {/*    </style>*/}
      {/*  </section>*/}

      {/*  <section className="stats-section">*/}
      {/*    <div className="container">*/}
      {/*      <div className="stats-row">*/}
      {/*        <div className="stat-column">*/}
      {/*          <div*/}
      {/*              className="download-card clickable"*/}
      {/*              onClick={() =>*/}
      {/*                  window.scrollTo({*/}
      {/*                    top: document.body.scrollHeight,*/}
      {/*                    behavior: 'smooth',*/}
      {/*                  })*/}
      {/*              }*/}
      {/*          >*/}
      {/*            <svg*/}
      {/*                xmlns="http://www.w3.org/2000/svg"*/}
      {/*                viewBox="0 0 64 64"*/}
      {/*                width="42"*/}
      {/*                height="42"*/}
      {/*                fill="none"*/}
      {/*                stroke="#2d6bff"*/}
      {/*                strokeWidth="3"*/}
      {/*                strokeLinecap="round"*/}
      {/*                strokeLinejoin="round"*/}
      {/*                className="pointer-icon"*/}
      {/*            >*/}
      {/*              <path d="M20 32v-9c0-2.2 1.8-4 4-4s4 1.8 4 4v13"/>*/}
      {/*              <path d="M28 36V16c0-2.2 1.8-4 4-4s4 1.8 4 4v16"/>*/}
      {/*              <path d="M36 36V20c0-2.2 1.8-4 4-4s4 1.8 4 4v12"/>*/}
      {/*              <path d="M44 36v-6c0-2.2 1.8-4 4-4s4 1.8 4 4v14c0 6.6-5.4 12-12 12H32c-6.6 0-12-5.4-12-12v-2"/>*/}
      {/*            </svg>*/}
      {/*            <span className="download-text">ThyroidPrint® testini yaptırmak istiyorum</span>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    </div>*/}

      {/*    <style>*/}
      {/*      {`*/}
      {/*  .stats-section .container {*/}
      {/*    margin: 40px auto;*/}
      {/*    max-width: 1200px;*/}
      {/*    text-align: center;*/}
      {/*  }*/}

      {/*  .stats-section .stats-row {*/}
      {/*    display: flex;*/}
      {/*    justify-content: center;*/}
      {/*  }*/}

      {/*  .stats-section .stat-column {*/}
      {/*    flex: 1 1 250px;*/}
      {/*    max-width: 300px;*/}
      {/*    padding: 0 15px;*/}
      {/*  }*/}

      {/*  .download-card {*/}
      {/*    display: flex;*/}
      {/*    flex-direction: column;*/}
      {/*    align-items: center;*/}
      {/*    background-color: #ffffff;*/}
      {/*    border-radius: 16px;*/}
      {/*    padding: 30px 20px;*/}
      {/*    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);*/}
      {/*    transition: box-shadow 0.3s ease, transform 0.3s ease;*/}
      {/*    cursor: pointer;*/}
      {/*  }*/}

      {/*  .download-card:hover {*/}
      {/*    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);*/}
      {/*    transform: translateY(-3px);*/}
      {/*  }*/}

      {/*  .pointer-icon {*/}
      {/*    margin-bottom: 12px;*/}
      {/*    animation: bounce 1s infinite;*/}
      {/*  }*/}

      {/*  .download-text {*/}
      {/*    font-size: 18px;*/}
      {/*    font-weight: 600;*/}
      {/*    color: #2d6bff;*/}
      {/*    text-align: center;*/}
      {/*  }*/}

      {/*  @keyframes bounce {*/}
      {/*    0%, 100% { transform: translateY(0); }*/}
      {/*    50% { transform: translateY(5px); }*/}
      {/*  }*/}
      {/*`}*/}
      {/*    </style>*/}
      {/*  </section>*/}


      <section className="faq-section">
        <div className="container">
          <h2 className="faq-title">Sıkça Sorulan Sorular</h2>
          {/*<p className="faq-description">*/}
          {/*  Size yardımcı olmak için buradayız, eğer cevabı bulamazsanız lütfen bizimle iletişime geçin, tüm*/}
          {/*  sorularınızı çözelim.*/}
          {/*</p>*/}

          <div className="faq-list">
            <div className={`faq-item ${activeFaq === 0 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(0)}>
                <div className="question-text">ThyroidPrint® testine nasıl ulaşabilirim?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 0 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 0 ? 'block' : 'none'}}>
                <p>ThyroidPrint® testi yapılan laboratuvar hakkında bilgi almak için bize ulaşabilirsiniz.
                </p>
              </div>
            </div>


            <div className={`faq-item ${activeFaq === 1 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(1)}>
                <div className="question-text">Moleküler Testler Nelerdir?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 1 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 1 ? 'block' : 'none'}}>
                <p>Genetik materyalin moleküler düzeyde analiz
                  edilmesine ve/veya saptanmasına olanak sağlayan tekniklerdir.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 2 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(2)}>
                <div className="question-text">Test sonucu kaç günde çıkar?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 2 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 2 ? 'block' : 'none'}}>
                <p>İnce iğne aspirasyon biyopsisi alınmasından itibaren 1-2 iş günü içerisinde sonuç teslim edilir.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 3 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(3)}>
                <div className="question-text">Nodülün ThyroidPrint® için uygun olup olmadığını nasıl anlaşılır?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 3 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 3 ? 'block' : 'none'}}>
                <p>Nodül 1 cm ile 5 cm arasındaysa ve biyopsi sonucu (FNA) nodülün Bethesda III veya IV kategorisinde
                  olduğunu gösteriyorsa ThyroidPrint için uygun hasta olabilir. Aynı şekilde, vaka her zaman bir uzman
                  doktor tarafından doğrulanmalıdır.</p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 4 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(4)}>
                <div className="question-text">Bethesda kategorisi nedir?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 4 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 4 ? 'block' : 'none'}}>
                <p>
                  Evrensel bir tiroid nodülü kategorizasyon sistemidir.<br/>
                  - Bethesda I: Yetersiz materyal<br/>
                  - Bethesda II: Benign nodül -%3 kanser riski<br/>
                  - Bethesda III ve IV: Belirsiz tanılı tiroid nodül, kanser riski %10-30 arasındadır<br/>
                  - Bethesda V: Şüpheli malignite kanser riski %60 ila %75<br/>
                  - Bethesda VI: Malign nodül<br/>
                </p>
              </div>
            </div>

            <div className={`faq-item ${activeFaq === 5 ? 'active' : ''}`}>
              <div className="faq-question" onClick={() => toggleFaq(5)}>
                <div className="question-text">Testin tanısal kesinliği nedir?</div>
                <div className="question-icon">
                  <div className="icon-line"></div>
                  <div className={`icon-line vertical ${activeFaq === 5 ? 'collapsed' : ''}`}></div>
                </div>
              </div>
              <div className="faq-answer" style={{display: activeFaq === 5 ? 'block' : 'none'}}>
                <p>ThyroidPrint testi, belirsiz Bethesda III veya IV tiroid nodülünün düşük riskli olup olmadığını %95
                  kesinlikle tahmin ederek tanı belirsizliğini ortadan kaldırabilir.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-row">
            {documents.map((doc, index) => (
                <div className="stat-column" key={index}>
                  <div className="download-card">
                    <Download className="download-icon"/>
                    <span className="download-text">{doc.name}</span>
                    <a
                        href={doc.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-button"
                    >
                      PDF Görüntüle
                    </a>
                  </div>
                </div>
            ))}
          </div>
        </div>

        <style>
          {`
                    .stats-section .container {
                        margin: 40px auto;
                        max-width: 1200px;
                        text-align: center;
                    }

                    .stats-section .stats-row {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 20px;
                        justify-content: center;
                    }

                    .stats-section .stat-column {
                        flex: 1 1 250px;
                        max-width: 300px;
                        background-color: #f8f9fa;
                        border-radius: 20px;
                        padding: 30px 20px;
                        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                        text-align: center;
                        transition: all 0.3s ease;
                    }

                    .stats-section .stat-column:hover {
                        background-color: #ffffff;
                        box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
                    }

                    .download-card {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }

                    .download-icon {
                        font-size: 48px;
                        color: #0a2540;
                        margin-bottom: 15px;
                    }

                    .download-text {
                        font-size: 18px;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 15px;
                    }

                    .download-button {
                        display: inline-block;
                        background-color: #0a2540;
                        color: #ffffff;
                        padding: 10px 20px;
                        border-radius: 25px;
                        font-weight: bold;
                        text-decoration: none;
                        transition: all 0.3s ease;
                    }

                    .download-button:hover {
                        background-color: #1c396a;
                    }
                `}
        </style>
      </section>
      {/* Locations Section */}
      {/*<section className="locations-section">*/}
      {/*  <div className="container">*/}
      {/*    <h2 className="locations-title">Neredeyiz?</h2>*/}

      {/*    <div className="locations-grid">*/}
      {/*      <div className="location">*/}
      {/*        <img*/}
      {/*          src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6537daaf00ae0a9101cd5f5a_Mapa-America.webp"*/}
      {/*          alt="America map" className="location-image"/>*/}
      {/*        <h4 className="location-title">America</h4>*/}
      {/*        <p className="location-country">Chile</p>*/}
      {/*        <p className="location-contact">*/}
      {/*          <a href="tel:+56942472410" className="location-phone">+56 9 4247 2410</a>*/}
      {/*        </p>*/}
      {/*      </div>*/}

      {/*      <div className="location">*/}
      {/*        <img*/}
      {/*          src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6537dac5943d51a41673281c_Mapa-Europa.webp"*/}
      {/*          alt="Europe map" className="location-image"/>*/}
      {/*        <h4 className="location-title">Europe</h4>*/}
      {/*        <p className="location-country">Spain</p>*/}
      {/*        <p className="location-address">*/}
      {/*          <a href="https://goo.gl/maps/7p2B78BPRJZ6iUbk7" target="_blank" rel="noreferrer"*/}
      {/*             className="location-link">*/}
      {/*            Provence 290 1-2, Barcelona.*/}
      {/*          </a>*/}
      {/*        </p>*/}
      {/*        <p className="location-contact">*/}
      {/*          <a href="tel:+34911863493" className="location-phone">+34 911 863 493</a><br/>*/}
      {/*          <a href="tel:+34933801582" className="location-phone">+34 933 801 582</a>*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</section>*/}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo">
              <a href="/">
                <img
                  src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/670586a7e0c37cc475e4d9fb_Logo_ThyroidPrint_White-p-500.png"
                  alt="ThyroidPrint" className="footer-logo-img"/>
              </a>
              <p className="footer-description">
              </p>
              <a href="http://omnigen.com.tr/" target={"_blank"}>
                <img
                    src={omnigenLogo}
                  alt="GeneproDX" className="footer-logo-secondary"/>
              </a>
                <p>
                    Bu sitedeki bilgiler sadece{" "}
                    <span style={{fontWeight: "700 "}}>
                    bilgilendirme amaçlıdır
                  </span>
                    , tanı ve tedavi için mutlaka doktorunuza başvurunuz.
                </p>

              {/*<ul className="social-links">*/}
              {/*  <li>*/}
              {/*    <a href="https://twitter.com/geneprodx?lang=es" target="_blank" rel="noreferrer">*/}
              {/*      <img*/}
              {/*        src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/65679002850cf0791a5b0d71_pngtree-white-twitter-icon-png-png-image_3562062-p-500.png"*/}
              {/*        alt="Twitter"/>*/}
              {/*    </a>*/}
              {/*  </li>*/}
              {/*  <li>*/}
              {/*    <a href="https://web.facebook.com/geneprodx?locale=es_LA" target="_blank" rel="noreferrer">*/}
              {/*      <img*/}
              {/*        src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/656790619dbe0b25d28b0e74_60fea6c83d624000048712b7-p-500.png"*/}
              {/*        alt="Facebook"/>*/}
              {/*    </a>*/}
              {/*  </li>*/}
              {/*  <li>*/}
              {/*    <a href="https://www.instagram.com/thyroid_print/" target="_blank" rel="noreferrer">*/}
              {/*      <img*/}
              {/*        src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/656e348ff3f18fe3ea15966e_instagram-icone-noir.png"*/}
              {/*        alt="Instagram"/>*/}
              {/*    </a>*/}
              {/*  </li>*/}
              {/*  <li>*/}
              {/*    <a href="https://www.linkedin.com/company/thyroidprintbygeneprodx/" target="_blank" rel="noreferrer">*/}
              {/*      <img*/}
              {/*        src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6579b45781573f6f7b8986a9_Linkedin-p-500.png"*/}
              {/*        alt="LinkedIn"/>*/}
              {/*    </a>*/}
              {/*  </li>*/}
              {/*  <li>*/}
              {/*    <a href="https://www.youtube.com/@testthyroidprint54" target="_blank" rel="noreferrer">*/}
              {/*      <img*/}
              {/*        src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/656e352c05c184888982fe37_youtube-icon.png"*/}
              {/*        alt="YouTube"/>*/}
              {/*    </a>*/}
              {/*  </li>*/}
              {/*</ul>*/}
            </div>

            <div className="footer-info" id="contact">

              <div className="footer-location">
                <h3 className="footer-info-title">OMNİGEN TIBBİ ÜRÜNLER A.Ş</h3>
                <ul className="footer-contact">
                  <li>
                    <a href="https://goo.gl/maps/7p2B78BPRJZ6iUbk7" target="_blank" rel="noreferrer">
                      Tozkoparan Mah. Haldun Taner Sokak No:27 D:7<br/> Alparslan İş Merkezi Merter-Güngören / İstanbul
                    </a>
                  </li>
                  <li>
                    <a href="tel:+902124813444">Tel : 0212 481 3 444 pbx</a>
                  </li>
                  <li>
                    Faks : 0212 481 5 444
                  </li>
                  <li>
                    <a href="mailto:info@omnigen.com.tr?subject=ThyroidPrint Hakkında Bilgi Talebi&body=Merhaba, daha fazla bilgi almak istiyorum.">E-mail
                      : info@omnigen.com.tr</a>
                  </li>
                </ul>
              </div>

              {/*<div className="footer-links">*/}
              {/*  <p>*/}
              {/*    <a href="https://www.thyroidprint.com/legal/terms-conditions" target="_blank" rel="noreferrer">Privacy*/}
              {/*      Policies</a>*/}
              {/*  </p>*/}
              {/*</div>*/}
            </div>
          </div>

          <div className="footer-copyright">
            <p>© Copyright 2025, All Rights Reserved by Omnigen</p>
          </div>
        </div>

        {/*<div className="whatsapp-button">*/}
        {/*  <a href="https://api.whatsapp.com/send/?phone=56942472410&text&type=phone_number&app_absent=0" target="_blank" rel="noreferrer">*/}
        {/*    <img src="https://cdn.prod.website-files.com/652d8c7c4f33bbe25d03ab29/6705938811967ecda1fce558_whatsapp-brix-templates-clonable.svg" alt="WhatsApp" />*/}
        {/*  </a>*/}
        {/*</div>*/}
      </footer>
    </div>
  );
}

export default App;
